/**
 * NativeWaves SMEP API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class EventsApi extends runtime.BaseAPI {
    /**
     * Get events in bulk.
     */
    async eventsBatchGetPostRaw(requestParameters, initOverrides) {
        if (requestParameters.smepEventBatchGet === null ||
            requestParameters.smepEventBatchGet === undefined) {
            throw new runtime.RequiredError('smepEventBatchGet', 'Required parameter requestParameters.smepEventBatchGet was null or undefined when calling eventsBatchGetPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/events/$batchGet`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.smepEventBatchGet,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get events in bulk.
     */
    async eventsBatchGetPost(requestParameters, initOverrides) {
        const response = await this.eventsBatchGetPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get AV sources.
     */
    async eventsEventIdAvSourcesGetRaw(requestParameters, initOverrides) {
        if (requestParameters.eventId === null ||
            requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId', 'Required parameter requestParameters.eventId was null or undefined when calling eventsEventIdAvSourcesGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/events/{eventId}/avSources`.replace(`{${'eventId'}}`, String(requestParameters.eventId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get AV sources.
     */
    async eventsEventIdAvSourcesGet(requestParameters, initOverrides) {
        const response = await this.eventsEventIdAvSourcesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete an event.
     */
    async eventsEventIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.eventId === null ||
            requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId', 'Required parameter requestParameters.eventId was null or undefined when calling eventsEventIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/events/{eventId}`.replace(`{${'eventId'}}`, String(requestParameters.eventId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete an event.
     */
    async eventsEventIdDelete(requestParameters, initOverrides) {
        await this.eventsEventIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get an event.
     */
    async eventsEventIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.eventId === null ||
            requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId', 'Required parameter requestParameters.eventId was null or undefined when calling eventsEventIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/events/{eventId}`.replace(`{${'eventId'}}`, String(requestParameters.eventId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get an event.
     */
    async eventsEventIdGet(requestParameters, initOverrides) {
        const response = await this.eventsEventIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get the published EXP manifest data (generated + overrides)
     */
    async eventsEventIdManifestGetRaw(requestParameters, initOverrides) {
        if (requestParameters.eventId === null ||
            requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId', 'Required parameter requestParameters.eventId was null or undefined when calling eventsEventIdManifestGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/events/{eventId}/manifest`.replace(`{${'eventId'}}`, String(requestParameters.eventId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get the published EXP manifest data (generated + overrides)
     */
    async eventsEventIdManifestGet(requestParameters, initOverrides) {
        const response = await this.eventsEventIdManifestGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit an event. Either the reference id or a start time must be specified.
     */
    async eventsEventIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.eventId === null ||
            requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId', 'Required parameter requestParameters.eventId was null or undefined when calling eventsEventIdPatch.');
        }
        if (requestParameters.smepEventEdit === null ||
            requestParameters.smepEventEdit === undefined) {
            throw new runtime.RequiredError('smepEventEdit', 'Required parameter requestParameters.smepEventEdit was null or undefined when calling eventsEventIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/events/{eventId}`.replace(`{${'eventId'}}`, String(requestParameters.eventId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.smepEventEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit an event. Either the reference id or a start time must be specified.
     */
    async eventsEventIdPatch(requestParameters, initOverrides) {
        const response = await this.eventsEventIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get the published EXP manifest data (generated + overrides)
     */
    async eventsEventIdProgramGetRaw(requestParameters, initOverrides) {
        if (requestParameters.eventId === null ||
            requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId', 'Required parameter requestParameters.eventId was null or undefined when calling eventsEventIdProgramGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/events/{eventId}/program`.replace(`{${'eventId'}}`, String(requestParameters.eventId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get the published EXP manifest data (generated + overrides)
     */
    async eventsEventIdProgramGet(requestParameters, initOverrides) {
        const response = await this.eventsEventIdProgramGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Manual trigger to wake up event processing. In very rare cases, event processing may have been stopped and not restarted by the automatic system.
     */
    async eventsEventIdWakePostRaw(requestParameters, initOverrides) {
        if (requestParameters.eventId === null ||
            requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId', 'Required parameter requestParameters.eventId was null or undefined when calling eventsEventIdWakePost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/events/{eventId}/wake`.replace(`{${'eventId'}}`, String(requestParameters.eventId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Manual trigger to wake up event processing. In very rare cases, event processing may have been stopped and not restarted by the automatic system.
     */
    async eventsEventIdWakePost(requestParameters, initOverrides) {
        await this.eventsEventIdWakePostRaw(requestParameters, initOverrides);
    }
    /**
     * Get a paginated list of events. If the filters: \'query\', \'health\' or \'timeRange\' are used, then the max total return count is limited to 10 000 even with pagination.
     */
    async eventsGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.environmentId !== undefined) {
            queryParameters['environmentId'] = requestParameters.environmentId;
        }
        if (requestParameters.workspaceId !== undefined) {
            queryParameters['workspaceId'] = requestParameters.workspaceId;
        }
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.health) {
            queryParameters['health'] = requestParameters.health;
        }
        if (requestParameters.timeRangeStart !== undefined) {
            queryParameters['timeRangeStart'] = requestParameters.timeRangeStart;
        }
        if (requestParameters.timeRangeEnd !== undefined) {
            queryParameters['timeRangeEnd'] = requestParameters.timeRangeEnd;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/events`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of events. If the filters: \'query\', \'health\' or \'timeRange\' are used, then the max total return count is limited to 10 000 even with pagination.
     */
    async eventsGet(requestParameters = {}, initOverrides) {
        const response = await this.eventsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new event. Either the reference id or a start time must be specified.
     */
    async eventsPostRaw(requestParameters, initOverrides) {
        if (requestParameters.smepEventInsert === null ||
            requestParameters.smepEventInsert === undefined) {
            throw new runtime.RequiredError('smepEventInsert', 'Required parameter requestParameters.smepEventInsert was null or undefined when calling eventsPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/events`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.smepEventInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new event. Either the reference id or a start time must be specified.
     */
    async eventsPost(requestParameters, initOverrides) {
        const response = await this.eventsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const EventsGetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
/**
 * @export
 */
export const EventsGetHealthEnum = {
    Ok: 'OK',
    Warning: 'WARNING',
    Critical: 'CRITICAL',
};
//# sourceMappingURL=EventsApi.js.map